import React, { Component, Context } from "react";
import { connect } from "react-redux";
import { NavLink, RouteComponentProps, withRouter } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import clsx from "clsx";
import { IAppStoreProps, IAppActionDispatches, mapAppDispatchToProps } from "../../redux/actions/app";
import { IAppState, mapAppStateToProps } from "../../redux/reducers/app";
import { ISitePage } from "../../laco-common/base/models/page";
import LayoutContext, { ILayoutContext } from "../../contexts/layout/LayoutContext";
import { withAuth, IAuthProps } from "../../laco-common/auth/AuthContext";
import "./Nav.scss";

export type NavProps = {
	hideDonate?: boolean;
	overrideNavigation?: ISitePage[];
	className?: string;
	white?: boolean;
};

class Nav extends Component<RouteComponentProps & IAppStoreProps & NavProps & IAuthProps> {
	static contextType: Context<ILayoutContext> = LayoutContext;
	private _sub: any;

	state = {
		mobileNavOpen: false,
	};

	componentDidMount() {
		const isMobileLayout = window.innerWidth < 1200;
		if (isMobileLayout) {
			// close mobile nav on navigation
			this.props.history.listen((location, action) => {
				if (this.state.mobileNavOpen) {
					this.setState({ mobileNavOpen: false });
				}
			});
		}
	}

	componentWillUnmount() {
		if (this._sub) this._sub.unsubscribe();
	}

	render() {
		return (
			<nav
				className={clsx(
					"navbar navbar-expand-xl pl-3",
					this.context.settings.isDesktopRes && this.props.className
				)}
			>
				<IconButton
					className={clsx(
						"d-xl-none nav-mobile-menu-btn",
						this.state.mobileNavOpen && "active",
						!this.state.mobileNavOpen && "text-white"
					)}
					edge="start"
					color="secondary"
					aria-label="Open Navigation Menu"
					onClick={() =>
						this.setState({
							mobileNavOpen: !this.state.mobileNavOpen,
						})
					}
				>
					<div className={clsx("menu-container", this.state.mobileNavOpen && "open")}>
						<div className="bar1"></div>
						<div className="bar2"></div>
						<div className="bar3"></div>
					</div>
				</IconButton>

				<ul
					className={clsx(
						"navbar-nav d-inline-flex",
						this.state.mobileNavOpen && "nav-open animated fadeIn fast-2",
						!this.state.mobileNavOpen && "nav-closed"
					)}
				>
					{!this.props.hideDonate && !process.env.REACT_APP_HIDE_DONATE && (
						<li className={"d-block d-xl-none d-flex justify-content-center"}>
							<NavLink to={"/donate"}>
								<button className="btn btn-primary mr-3" style={{ minWidth: "100px" }}>
									Donate
								</button>
							</NavLink>

							{!this.props.authContext.isAuthenticated && (
								<NavLink to={"/login"}>
									<button className="btn btn-outline-light">Member Login</button>
								</NavLink>
							)}
						</li>
					)}

					{(this.props.overrideNavigation || this.props.navigation).map((page: ISitePage) => {
						const hasChildren: boolean = !!page.pages && !!page.pages.filter((p) => p.active)?.length;
						if (!page.active) return null;
						if (
							page.firewireUsersOnly &&
							this.props.authContext.userPayload?.role !== "user" &&
							this.props.authContext.userPayload?.role !== "admin" &&
							!this.props.authContext.userPayload?.superAdmin
						) {
							return null;
						}

						return (
							<li
								key={page.id}
								className={clsx(
									"nav-item",
									hasChildren && "has-children",
									page.path === "" && "home-link"
								)}
							>
								{(!!page.path || page.id === "home") && (
									<NavLink
										to={`/${page.path}`}
										activeClassName="selected"
										// className={clsx(
										// 	this.props.overrideNavigation &&
										// 		// page.path &&
										// 		// page.path !== "/" &&
										// 		// (this.props.location.pathname.length - page.path) &&
										// 		this.props.location.pathname.substr(1).startsWith(page.path) &&
										// 		"selected"
										// )}
										exact={
											page.id !== "events" &&
											page.id !== "marketplace" &&
											page.id !== "page-messages"
										}

										// className={clsx(this.isActiveChildRoute(page) && "selected")}
									>
										{page.navTitle || page.title}
									</NavLink>
								)}
								{!page.path && page.id !== "home" && (
									<span
										className={clsx(
											"nav-no-link",
											!!page.pages?.find((p: ISitePage) =>
												this.props.location.pathname.includes(p.path)
											) && "selected"
										)}
									>
										{page.navTitle || page.title}
									</span>
								)}
								{!!hasChildren && (
									<ul className="nav-category animated fadeIn fast-1">
										{page.pages.map((p: ISitePage) => {
											if (!p.active) return null;
											return (
												<NavLink key={p.id} to={`/${p.path}`} activeClassName="selected" exact>
													<li key={p.id}>{p.navTitle || p.title}</li>
												</NavLink>
											);
										})}
									</ul>
								)}
							</li>
						);
					})}
				</ul>
			</nav>
		);
	}
}

export default connect<IAppState, IAppActionDispatches, NavProps>(
	mapAppStateToProps,
	mapAppDispatchToProps
)(withAuth(withRouter(Nav)));
